// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__26EWT","label":"Labeled_label__29jEV","divider":"Labeled_divider__2CGF1"};